export const breakpoints = {
  xsm: '300px',
  sm: '576px',
  md: '768px',
  lg: '1024px',
  xlg: '1200px'
};
